import { PrismaEnums } from '@airreading/schema/browser';
import { z } from 'zod';
import { paginatedRequest, paginatedResponse } from './util-schema-types.js';

export const { BookType } = PrismaEnums;
export type BookType = PrismaEnums.BookType;
export const bookTypeSchema = z.nativeEnum(BookType);

export const bookSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: bookTypeSchema,
  tags: z.string().array(),
});

export type Book = z.infer<typeof bookSchema>;

export const getBooksQuerySchema = z.object({
  query: z.string().optional(),
});
export type GetBooksQuery = z.infer<typeof getBooksQuerySchema>;

export const getBooksPaginatedQuerySchema = paginatedRequest.extend(getBooksQuerySchema.shape);
export type GetBooksPaginatedQuery = z.infer<typeof getBooksPaginatedQuerySchema>;

export const getBooksResultsSchema = paginatedResponse.extend({
  books: z.array(bookSchema),
});

export type GetBooksResults = z.infer<typeof getBooksResultsSchema>;

export const createBookOptionsSchema = z.object({
  name: z.string(),
  type: bookTypeSchema,
  tags: z.string().array(),
});

export type CreateBookOptions = z.infer<typeof createBookOptionsSchema>;

export const updateBookOptionsSchema = z.object({
  name: z.string(),
  type: bookTypeSchema,
  tags: z.string().array(),
});

export type UpdateBookOptions = z.infer<typeof updateBookOptionsSchema>;

export const createBookCsvRow = z.object({
  name: z.string(),
  type: z.nativeEnum(PrismaEnums.BookType),
  tags: z.string(),
});
export type CreateBookCsvRow = z.infer<typeof createBookCsvRow>;
export const CreateBooksCsvFormKeys = {
  csvFile: 'csvFile',
} as const;
